import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectKrcAgeRangeItemNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import {
  type BuildingBlockNodeConfig,
  type EditAsideThemes,
  NodeType,
} from '@nodeTypeConfig/configTypes';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { optionalTitleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const krcAgeRangeThemeComponent: EditAsideThemes = {
  component: 'themes',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: 'Leeftijdsbereik',
  options: {
    referenceFrameHref: referenceFrames.krc,
    types: [ContentType.KRC_AGE_RANGE],
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const preventIndividualDelete = (node: any, state: any) => {
  if (state.selections.includes(node.$$relation.key)) {
    return {
      message:
        'Een leeftijdsbereik item kan niet individueel verwijderd worden. Verwijder het doelenset item.',
    };
  }
  return true;
};

const KRC_AGE_RANGE_ITEM: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcAgeRangeItemNode,
  information: {
    single: 'Leeftijdsbereik item',
    plural: 'Leeftijdsbereik items',
  },
  buildingBlocks: [{ type: NodeType.KRC_CURRICULUM_GOAL }],
  edit: [identifierComponent, optionalTitleComponent, krcAgeRangeThemeComponent],
  readOnlyNode: true,
  deleteValidations: [preventIndividualDelete],
  isNotDraggable: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default KRC_AGE_RANGE_ITEM;
